import React from "react";

import StyleNotExistModal from "@is/features/Activities/StyleNotExistModal";

import useManageSettingsDrawerContent from "./hooks/useManageSettingsDrawerContent";

const SettingsDrawerContent = () => {
  const { content, showStyleNotExistModal, handleCloseModal } =
    useManageSettingsDrawerContent();

  return (
    <>
      {content}
      {showStyleNotExistModal && (
        <StyleNotExistModal onClose={handleCloseModal} />
      )}
    </>
  );
};

export default SettingsDrawerContent;
